import React from 'react';
import AboutTeam from './AboutTeam/AboutTeam';
import '../Team/Team.css';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import Newsletter from '../Newsletter/Newsletter';
import WorkSection from './Work';

const Team = () => {
    const teamMembers = [
        {
            id: 1,
            name: 'Rohan Sharma',
            role: 'CEO & Founder',
            img: '/m.jpg',
            social: {
                facebook: 'https://facebook.com/rohan.sharma',
                twitter: 'https://twitter.com/rohan.sharma',
                instagram: 'https://instagram.com/rohan.sharma',
                linkedin: 'https://linkedin.com/in/rohan.sharma'
            },
        },
        {
            id: 2,
            name: 'Priya Verma',
            role: 'Creative Director',
            img: '/mf.jpg',
            social: {
                facebook: 'https://facebook.com/priya.verma',
                twitter: 'https://twitter.com/priya.verma',
                instagram: 'https://instagram.com/priya.verma',
                linkedin: 'https://linkedin.com/in/priya.verma'
            },
        },
        {
            id: 3,
            name: 'Aditya Kumar',
            role: 'Tech Lead',
            img: '/m.jpg',
            social: {
                facebook: 'https://facebook.com/aditya.kumar',
                twitter: 'https://twitter.com/aditya.kumar',
                instagram: 'https://instagram.com/aditya.kumar',
                linkedin: 'https://linkedin.com/in/aditya.kumar'
            },
        },
        {
            id: 4,
            name: 'Sneha Patil',
            role: 'Marketing Head',
            img: '/mf.jpg',
            social: {
                facebook: 'https://facebook.com/sneha.patil',
                twitter: 'https://twitter.com/sneha.patil',
                instagram: 'https://instagram.com/sneha.patil',
                linkedin: 'https://linkedin.com/in/sneha.patil'
            },
        },
        {
            id: 5,
            name: 'Aditya Kumar',
            role: 'Tech Lead',
            img: '/m.jpg',
            social: {
                facebook: 'https://facebook.com/aditya.kumar',
                twitter: 'https://twitter.com/aditya.kumar',
                instagram: 'https://instagram.com/aditya.kumar',
                linkedin: 'https://linkedin.com/in/aditya.kumar'
            },
        },
        {
            id: 6,
            name: 'Sneha Patil',
            role: 'Marketing Head',
            img: '/mf.jpg',
            social: {
                facebook: 'https://facebook.com/sneha.patil',
                twitter: 'https://twitter.com/sneha.patil',
                instagram: 'https://instagram.com/sneha.patil',
                linkedin: 'https://linkedin.com/in/sneha.patil'
            },
        },
    ];

    return (
        <>
            <AboutTeam />
{/*--
            <div className="team-container">
                <div className="team-hero">
                    <div className="team-intro animate-slide-in-left">
                    <h1>Brilliant Minds <span>Shaping the Future Ahead</span> </h1>
                        <p>We’re a dedicated team of experts, combining creativity and precision to deliver inspiring solutions. Our collective energy empowers transformation and drives meaningful outcomes.</p>
                        <Link to="/contact">
                            <button className="contact-button">
                                Connect With Us
                            </button>
                        </Link>
                    </div>

                    <div className="team-image-container animate-slide-in-right">
                        <div className="image-frame"></div>
                        <img src="/s1.jpg" alt="Team working together" className="hero-image" />
                    </div>
                </div>

                <div className="team-grid">
                    {teamMembers.map((member, index) => (
                        <div
                            key={member.id}
                            className="team-member-card animate-fade-in"
                            style={{ animationDelay: `${index * 0.1}s` }}
                        >
                            <div className="member-image-container">
                                <img src={member.img} alt={member.name} className="member-image" />
                                <div className="social-overlay">
                                    <div className="social-icons">
                                        {member.social.facebook && (
                                            <a href={member.social.facebook} target="_blank" rel="noopener noreferrer">
                                                <FaFacebookF className="icont" />
                                            </a>
                                        )}
                                        {member.social.twitter && (
                                            <a href={member.social.twitter} target="_blank" rel="noopener noreferrer">
                                                <FaTwitter className="icont" />
                                            </a>
                                        )}
                                        {member.social.instagram && (
                                            <a href={member.social.instagram} target="_blank" rel="noopener noreferrer">
                                                <FaInstagram className="icont" />
                                            </a>
                                        )}
                                        {member.social.linkedin && (
                                            <a href={member.social.linkedin} target="_blank" rel="noopener noreferrer">
                                                <FaLinkedinIn className="icont" />
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="member-info">
                                <h3>{member.name}</h3>
                                <p className="role">{member.role}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            --*/}
<WorkSection/>
            <Newsletter />
        </>
    );
}

export default Team;
